export default "__VITE_ASSET__BWKdQ3m3__"